import { useState, useMemo } from 'react';
import {
  ExtendedOilData,
  HandleAnalysisChange as HandleOilAnalysisChange,
  getDescriptionFromRow,
} from 'components/Evidences/Helpers/helper';
import { useOilAnalysisQuery } from 'queries/externalReferences/queries';
export const EVIDENCE_DEFAULT_PERIOD = '730';
export const useOilAnalysis = (assetId: string, activeTab?: string) => {
  const [period, setPeriod] = useState(EVIDENCE_DEFAULT_PERIOD);
  const [selections, setSelections] = useState<Record<string, boolean>>({});
  const { data, isLoading } = useOilAnalysisQuery(assetId, period, {
    enabled: activeTab === 'OIL_ANALYSIS',
  });

  //endpoint getEditedOilAnalysis ainda não existe - alterar pelo correto quando estiver pronto
  const { data: editedOilAnalysisData } = useOilAnalysisQuery(assetId, period, {
    enabled: activeTab === 'OIL_ANALYSIS',
  });

  const filteredData = useMemo(() => {
    if (!data) return [];

    return (data as ExtendedOilData[]).map((row) => {
      const description = getDescriptionFromRow(row);
      const newRow = { ...row };

      Object.keys(newRow).forEach((columnKey) => {
        const selectionKey = `${description}_${columnKey}`;
        if (selections[selectionKey]) {
          newRow[`selected_${columnKey}`] = 'true';
        }
      });

      return newRow;
    });
  }, [data, selections]);

  const hasAnySelectedCells = useMemo(() => {
    return Object.values(selections).some((selected) => selected);
  }, [selections]);

  const handleCellSelectionChange = ({
    description,
    columnKey,
    value,
  }: HandleOilAnalysisChange) => {
    const selectionKey = `${description}_${columnKey}`;
    setSelections((prev) => ({
      ...prev,
      [selectionKey]: value,
    }));
  };

  const handlePeriodChange = (value: string) => {
    setPeriod(value);
    setSelections({});
  };

  const clearSelections = () => {
    setSelections({});
  };

  return {
    period,
    filteredData,
    hasAnySelectedCells,
    handleCellSelectionChange,
    handlePeriodChange,
    clearSelections,
    isLoading,
    editedOilAnalysisData,
  };
};
